//@flow
import * as React from 'react'

import { useLabelStyles } from './styles'
import { isValidHTMLTag } from '~/core/utils/functions'

type LabelProps = {
  children: React.Node,
  as?: string
}

const Label = ({ children, as = 'label', ...props }: LabelProps) => {
  const classes = useLabelStyles()
  const Component = isValidHTMLTag(as) ? as : 'label'
  return (
    <Component className={classes.labelWrapper} {...props}>
      {children}
    </Component>
  )
}

export default Label
